module.exports = __webpack_public_path__ + "static/img/member_banner.jpg";